var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"video",staticClass:"video-js vjs-default-skin",attrs:{"id":"videoPlayer","src":_vm.videoPath,"controls":"","width":"100%","controlslist":"nodownload"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }